import { createContext, useContext } from 'react'

export type PageIsolationSelection = {
  pageId: string
  nodeIds: string[]
  badges?: Record<string, string>
}

export type IsolationNodeSummary = {
  pageId: string
  nodeId: string
  label: string
  subtitle?: string
}

export type IsolationController = {
  selection: PageIsolationSelection[]
  highlightedNodeIds?: string[]
  pickColor?: string
  onToggleNode?: (node: IsolationNodeSummary) => void
}

const IsolationControllerContext = createContext<
  IsolationController | undefined
>(undefined)

export const IsolationControllerProvider = IsolationControllerContext.Provider

export const useIsolationController = (): IsolationController | undefined =>
  useContext(IsolationControllerContext)
